@switch (displayType) {
    @case (BetBuilderDisplayType.EntainUIInOverlay) {
        <ms-betbuilder-overlay-trigger-banner [event]="event" />
        <div class="ogp-bet-builder-precreated">
            @if (!preCreated?.hasMarkets) {
                <ms-bet-builder-help
                    [collapsible]="false"
                    [sportId]="event.sport.id"
                    [eventName]="event.name"
                    [leagueId]="event.league.id"></ms-bet-builder-help>
            }
            @if (preCreated?.ambassadorsMarkets?.length) {
                <ms-bet-builder-market [event]="event" [fixtureId]="preCreated?.fixtureId" [builderMarkets]="preCreated?.ambassadorsMarkets">
                </ms-bet-builder-market>
            }
            @if (preCreated?.promotedMarkets?.length) {
                <ms-bet-builder-market
                    [event]="event"
                    [fixtureId]="preCreated?.fixtureId"
                    [builderMarkets]="preCreated?.promotedMarkets"></ms-bet-builder-market>
            }
        </div>
    }
    @case (BetBuilderDisplayType.EntainUIInMarketBoard) {
        <ms-betbuilder-market-list [eventData]="event" [source]="source"></ms-betbuilder-market-list>
    }
    @case (BetBuilderDisplayType.Classic) {
        <div class="betbuilder-button-and-help-group">
            <ms-bet-builder-custom-message [event]="event"></ms-bet-builder-custom-message>
            <ms-bet-builder-button [event]="event" [hasPreCreated]="preCreated?.hasMarkets"></ms-bet-builder-button>
            <ms-bet-builder-help
                [collapsible]="preCreated?.hasMarkets"
                [sportId]="event.sport.id"
                [eventName]="event.name"
                [leagueId]="event.league.id"></ms-bet-builder-help>
        </div>
        @if (preCreated?.ambassadorsMarkets?.length) {
            <ms-bet-builder-market [event]="event" [fixtureId]="preCreated?.fixtureId" [builderMarkets]="preCreated?.ambassadorsMarkets">
            </ms-bet-builder-market>
        }
        @if (preCreated?.promotedMarkets?.length) {
            <ms-bet-builder-market
                [event]="event"
                [fixtureId]="preCreated?.fixtureId"
                [builderMarkets]="preCreated?.promotedMarkets"></ms-bet-builder-market>
        }
    }
}
